<template>
  <div class="fans-card">
    <div class="label">粉丝分析</div>
    <div class="fans-wrap" v-if="list.length">
      <div class="item" v-for="(item, index) in list" :key="index">
        <div class="right">{{ item.title }}</div>
        <div class="left">
          <template v-if="item.value.length">
            <div class="tag" v-for="(item, index) in item.value" :key="index">{{ item }}</div>
          </template>
          <div v-else class="yx-color-info">{{ item.empty }}</div>
        </div>
      </div>
    </div>
    <div class="stance" v-else>
      <div class="i-fans-empty"></div>
      <div class="mt-12">暂无粉丝分析</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'fansCard',
  props: {
    list: {
      type: Array,
      default: _ => []
    }
  }
}
</script>

<style lang="less" scoped>
.fans-card {
  border-bottom: 1px #eee solid;
  .label {
    font-size: 16px;
    font-weight: bold;
  }
  .fans-wrap {
    margin-top: 8px;
    padding-bottom: 32px;
    .item {
      margin-top: 4px;
      display: flex;
      align-items: baseline;
      font-size: 14px;
      .right {
        width: 88px;
        text-align: left;
        color: #666;
        line-height: 24px;
        margin-top: 12px;
      }
      .left {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        .tag {
          border-radius: 2px;
          border: 1px solid #eee;
          color: #333;
          line-height: 12px;
          padding: 6px 8px;
          margin-right: 12px;
          margin-top: 12px;
        }
      }
    }
  }
  .stance {
    text-align: center;
    font-size: 14px;
    color: #999;
    padding: 32px 0 52px;
  }
}
</style>
